import SectionHeading from "@/components/base/SectionHeading";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/site";

export default function FaqSection() {
  const homeFaqs = faqs.slice(0, 5);

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: homeFaqs.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };

  return (
    <section className="bg-background-50">
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <div className="max-w-editorial mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="常见问题"
              title="关于网暴黑料，人们最常问的那些事"
              description="这些问题的答案来自当事人回访与公开的求助经验整理，希望帮你少走一些弯路。"
            />
          </div>
          <div className="lg:col-span-8">
            <FaqAccordion items={homeFaqs} idPrefix="home-faq" />
          </div>
        </div>
      </div>
    </section>
  );
}